<template>
  <div class="relation-filters">
    <common-tabs v-model="tab" :items="tabItems" :converter="$tfo" class="item-tabs"></common-tabs>

    <level-filter v-if="levelState" :state="levelState" :index="levelIndex"></level-filter>
    <cluster-filter v-else></cluster-filter>
    <!--    <-filter :playing="false" base-route="contacts" :skip-page="true" v-else></clusters-filter>-->
  </div>
</template>

<script>
import ClustersFilter from '../clusters/filter';
import LevelFilter from './level.filter';
import ClusterFilter from '../clusters/filter';

export default {
  name: 'contacts-filter',
  components: { ClusterFilter, LevelFilter, ClustersFilter },
  data: function () {
    return { tab: 'clusters' };
  },
  computed: {
    levelIndex() {
      return this.tab.indexOf('level') > -1 ? parseInt(this.tab.substring(5, 6)) : null;
    },
    levelState() {
      return this.tab.indexOf('level') > -1 ? this.$store.state.face_contacts.levels[this.levelIndex] : null;
    },
    state() {
      return this.$store.state.face_contacts;
    },
    tabItems() {
      const items = this.state.levels
        .map((v, k) => (v.current ? { label: this.$tf('circle') + (k + 1), name: 'level' + k } : null))
        .filter((v, k) => !!v && k < 3);
      return [{ name: 'clusters' }, ...items];
    }
  }
};
</script>
